import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie/services/cookies.service';

import { ApplicationStateService } from './services/application-state.service';
import { CurrentUserService } from './services/current-user.service';
import { QuoteInfoService } from './services/quote-info.service';
import { BrowserWidthService } from './services/browser-width.service';
import { UserPricingViewService } from './services/user-pricing-view.service';
import { QuoteService } from './services/quote.service';
import { AuditHistoryService } from './services/audit-history.service';
import { QuoteApprovalService } from './services/quote-approval.service';
import { HttpResponseService } from './services/httpresponse-service';
import { ToasterService, ToasterConfig } from 'angular2-toaster';
import { throwErrorToast } from './utilities/lang';
import { QuoteRevisionInfoService } from './services/quote-revision-info.service';

import { CurrentUser } from './model/current-user';
import { Quote } from './model/quote';
import { Constants } from './model/constants';
import { InvalidQuote } from './model/invalid-quote';
import { HttpErrorResponse } from './model/httperror-response';
import { QuoteRevision } from './model/quote-revision';


import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';

import '../style/app.scss';

@Component({
  selector: 'my-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')]
})
export class AppComponent implements OnInit, OnDestroy {
  cmhBaseUrl: string;
  mchBaseUrl: string;
  approvalStatusText: string = '';
  approvalStatusHeading: string = '';

  windowWidth: number;

  canAccessQuote: boolean = true;
  unlockQuotePostCallMade: boolean = false;  
  showQuoteHistoryModal: boolean = false;
  quoteLockedByOtherCmhUser: boolean = false;
  showInvalidQuoteApprovalModal: boolean = false;
  canAccessPage: boolean = true;
  cannotEditQuote: boolean = false;

  currentUser: CurrentUser;
  quote: Quote;
  invalidQuote: InvalidQuote;
  subscription: Subscription = new Subscription();
  httpErrorResponse: HttpErrorResponse = new HttpErrorResponse(0, '');
  httperrormessage: string;
  httperrortitle: string;
  showHttpModal = false;
  throwErrorToast = throwErrorToast;
  config: ToasterConfig = new ToasterConfig({
    positionClass:
      this.bw.getDisplayMode().width.innerWidth < 769
        ? 'toast-bottom-full-width'
        : 'toast-bottom-right',
    tapToDismiss: false
  });

  constructor(
    private currentUserService: CurrentUserService,
    private quoteInfoService: QuoteInfoService,
    private applicationStateService: ApplicationStateService,
    public bw: BrowserWidthService,
    private router: Router,
    private cookieService: CookieService,
    private userPricingViewService: UserPricingViewService,
    private quoteService: QuoteService,
    private auditHistoryService: AuditHistoryService,
    private quoteApprovalService: QuoteApprovalService,
    private httpResponseService: HttpResponseService,
    public toasterService: ToasterService,
    public quoteRevisionInfoService: QuoteRevisionInfoService,
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics
  ) {
    if (localStorage.getItem('CLU') === null) {
      window.location.href =
        '/web/#!/login/expired?returnUrl=' + window.location.pathname;
    } else {
      this.currentUser = JSON.parse(atob(localStorage.getItem('CLU')));
      if (this.currentUser['Roles']) {
        this.currentUser.roles = this.currentUser['Roles'];
      }
      this.currentUser.isOptionsAdmin =
        this.currentUser.roles &&
        this.currentUser.roles.includes('MyCustomHomes_Admin')
          ? true
          : false;
      this.currentUser.isMCHUser =
        this.currentUser.roles &&
        this.currentUser.roles.includes('MyCustomHomes')
          ? true
          : false;

      this.currentUser.roles.includes('MyCustomHomes') &&
      !window.location.href.includes('options-admin') &&
      !window.location.href.includes('quote-approvals')
        ? this.currentUserService.mchUserStatus$.next(true)
        : this.currentUserService.mchUserStatus$.next(false);
      this.currentUserService.currentUser$.next(this.currentUser);
      this.mchBaseUrl = this.cookieService.get('mchBaseUrl');
    }

    angulartics2GoogleAnalytics.startTracking();
  }

    ngOnInit() {
    const windowClickSub = Observable.fromEvent(window, 'click').subscribe(
      x => {
        let xPos = x['clientX'] || x['x'];

        if (xPos > 90) {
          this.quoteInfoService.showSideNavFlyOut$.next(false);
          }
        // if (xPos < (this.windowWidth - 425)) {
        //     this.quoteInfoService.showUserMenu$.next(false);
        // }          
      }
    );
    this.subscription.add(windowClickSub);

    const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
      this.currentUser = x;
      if (x !== undefined && x !== null && x.cmhUserId !== 0) {
        this.userPricingViewService
          .getUserPricingView(x.cmhUserId)
          .subscribe(pricingView => {
            if (pricingView !== undefined && pricingView !== null) {
              this.quoteInfoService.currentPricingView$.next(
                pricingView.PricingView
              );
              this.applicationStateService.setPricingView(
                pricingView.PricingView
              );
            } else {
              this.quoteInfoService.currentPricingView$.next(2);
              this.applicationStateService.setPricingView(2);
            }
          });
      } else {
        this.quoteInfoService.currentPricingView$.next(2);
        this.applicationStateService.setPricingView(2);
      }
    });
    this.subscription.add(currentUserSub);

    const quoteSub = this.quoteInfoService.quote$.subscribe(quote => {
      this.quote = quote;

      if (this.canAccessStandalonePages(this.currentUser)) {
        this.canAccessPage = true;
        // this.bw.modalActive$.next(true);
        this.standalonePagesRedirect(this.currentUser);
        // this.wrongRetailerRedirect(quote, this.currentUser);
        // this.quoteLockedRedirect(quote, this.currentUser);
        if (this.currentUser.isMCHUser) {
          this.lockQuote(quote, this.currentUser);
        }
        this.quoteSubmittedRedirect(quote, this.currentUser);
      } else {
        this.canAccessPage = false;
        this.bw.modalActive$.next(false);
      }
    });
    this.subscription.add(quoteSub);
    const canAccessQuoteSub = this.quoteInfoService.canAccessQuote$.subscribe(
      x => {
        this.canAccessQuote = x;
        this.bw.modalActive$.next(x);
      }
    );
    this.subscription.add(canAccessQuoteSub);
    const showQuoteHistoryModalSub = this.auditHistoryService.showQuoteHistoryModal$.subscribe(
      showModal => {
        this.showQuoteHistoryModal = showModal;
        this.bw.setScroll(showModal);
      }
    );
    this.subscription.add(showQuoteHistoryModalSub);
    const showInvalidQuoteApprovalModalSub = this.quoteApprovalService.showInvalidQuoteApprovalModal$.subscribe(
      x => {
        this.showInvalidQuoteApprovalModal = x;
        this.bw.setScroll(x);
      }
    );
    this.subscription.add(showInvalidQuoteApprovalModalSub);
    const invalidQuoteSub = this.quoteApprovalService.invalidQuote$.subscribe(
      x => {
        this.invalidQuote = x;
      }
    );
    this.subscription.add(invalidQuoteSub);
    this.cmhBaseUrl = this.cookieService.get('cmhBaseUrl');

    const httpResponseSub = this.httpResponseService.httpErrorResponse$.subscribe(
      x => {
        if (x !== null) {
          this.showHttpModal = false;
          this.httpErrorResponse = x;
          this.bw.setScroll(x.errorCode > 0);
          this.httperrormessage = x.errorMessage;
          switch (this.httpErrorResponse.errorCode) {
            case Constants.HttpErrorCodes.RETAILERNOTAUTHORIZED:
              // retailer does not have authorization to quote
              this.httperrortitle = 'Unauthorized User';
              this.showHttpModal = true;
              break;
            case Constants.HttpErrorCodes.QUOTELOCKED:
              // quote locked
              this.httperrortitle = 'Quote Locked';
              this.showHttpModal = true;
              break;
            case Constants.HttpErrorCodes.UNAUTHORIZED:
              this.httperrortitle = 'Unauthorized User';
              this.showHttpModal = true;
              break;
            case 500:
              this.throwErrorToast();
              break;
          }
        }
      }
    );
    this.subscription.add(httpResponseSub);
  }

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHander(event) {        
        this.PostCall();
        return true;
    }

    @HostListener('window:unload', ['$event'])
    unloadHandler(event) {
        this.PostCall();
    }    

    PostCall() {
        if (!this.unlockQuotePostCallMade && this.quote) {
            this.unlockQuotePostCallMade = true;
            this.quoteLockedByOtherCmhUser = false;
            this.unlockQuote(this.quote, this.currentUser);
        }            
    }

  redirectToCmh() {
    this.quoteInfoService.canAccessQuote$.next(false);
    this.httpResponseService.httpErrorResponse$.next(null);
    window.location.href = `${this.cmhBaseUrl}#!/sales/quotes`;
  }

  canAccessStandalonePages(currentUser: CurrentUser): boolean {
    if (
      currentUser !== undefined &&
      currentUser !== null &&
      (window.location.href.includes('options-admin') ||
            window.location.href.includes('quote-approvals') ||
            window.location.href.includes('truexp'))
    ) {
      if (
        window.location.href.includes('options-admin') &&
        !currentUser.roles.includes('MyCustomHomes_Admin')
      ) {
        return false;
      }
      if (
        window.location.href.includes('quote-approvals') &&
        !this.currentUser.roles.includes('MyCustomHomes_Quote_Approver') &&
        !this.currentUser.roles.includes('MyCustomHomes_OverrideApprover')
      ) {
        return false;
        }
        if (window.location.href.includes('truexp') &&
            !this.currentUser.roles.includes('TRU_Express')) {
            return false;
        }
    }
    return true;
  }

  standalonePagesRedirect(currentUser: CurrentUser) {
    if (!this.canAccessStandalonePages(currentUser)) {
      this.quoteInfoService.canAccessQuote$.next(false);
    }
  }

  //  wrongRetailerRedirect(quote: Quote, currentUser: CurrentUser) {
  //    if (((quote !== undefined && quote !== null
  //        && currentUser !== undefined && currentUser !== null
  //        && quote.retailerNumber !== undefined && quote.retailerNumber !== null && quote.retailerNumber !== ''
  //        && currentUser.retailerNumber !== undefined && currentUser.retailerNumber !== null && currentUser.retailerNumber !== ''
  //        && currentUser.availableRetailers !== undefined
  //        && currentUser.availableRetailers !== null
  //        && currentUser.availableRetailers.length > 0))) {
  //        if (!currentUser.roles.includes('MyCustomHomes')) {
  //            this.quoteInfoService.canAccessQuote$.next(false);
  //            this.unlockQuote(quote, currentUser);
  //        } else if (!currentUser.availableRetailers.find(x => x.retailerNumber === quote.retailerNumber)) {
  //            this.quoteInfoService.canAccessQuote$.next(false);
  //            this.unlockQuote(quote, currentUser);
  //        } else if (currentUser.availableRetailers.find(x => x.retailerNumber === quote.retailerNumber)
  //            && window.location.href.includes('quote-summary')) {
  //            this.quoteInfoService.canAccessQuote$.next(true);
  //        }
  //    } else {
  //        this.quoteInfoService.canAccessQuote$.next(true);
  //    }
  //  }

  //  quoteLockedRedirect(quote: Quote, currentUser: CurrentUser) {
  //    if ((((quote !== undefined && quote !== null
  //        && currentUser !== undefined && currentUser !== null
  //        && quote.userId !== undefined && quote.userId !== null
  //        && quote.userId > 0
  //        && currentUser.cmhUserId !== undefined && currentUser.cmhUserId !== null
  //        && currentUser.cmhUserId !== ''))
  //        && (Number(currentUser.cmhUserId) !== quote.LockedBy && quote.LockedBy !== 0)
  //        && quote.IsLocked)) {
  //        this.quoteLockedByOtherCmhUser = true;
  //        this.quoteInfoService.canAccessQuote$.next(false);
  //    } else {
  //        this.quoteLockedByOtherCmhUser = false;
  //        if (currentUser.isMCHUser) {
  //            this.lockQuote(quote, currentUser);
  //        }
  //    }
  //  }

  quoteSubmittedRedirect(quote: Quote, currentUser: CurrentUser) {
    if (
      window.location.href.includes('quote-summary') ||
      window.location.href.includes('quote-history')
    ) {
      this.cannotEditQuote = false;
      this.bw.modalActive$.next(false);
      this.quoteInfoService.canAccessQuote$.next(true);
    } else {
      if (
        quote !== undefined &&
        quote !== null &&
        currentUser !== undefined &&
        currentUser !== null &&
        currentUser.isPlantUser !== undefined &&
        currentUser.isPlantUser !== null &&
        currentUser.isPlantUser === false
      ) {
        this.approvalStatusHeading =
          quote !== undefined && quote !== null
            ? Constants.ApprovalStatusHeading[quote.QuoteStatusesID]
            : '';
        this.approvalStatusText =
          quote !== undefined && quote !== null
            ? Constants.ApprovalStatusText[quote.QuoteStatusesID]
            : '';
        this.bw.modalActive$.next(false);
        this.cannotEditQuote = false;
        // this.quoteInfoService.canAccessQuote$.next(true);
      } else {
        this.cannotEditQuote = false;
        this.bw.modalActive$.next(false);
      }
    }
  }

    lockQuote(quote: Quote, currentUser: CurrentUser) {
        
    if (
      quote !== undefined &&
      quote !== null &&
      currentUser !== undefined &&
      currentUser !== null &&
      quote.userId !== undefined &&
      quote.userId !== null &&
      quote.userId > 0 &&
      currentUser.cmhUserId !== undefined &&
      currentUser.cmhUserId !== null &&
      currentUser.cmhUserId !== '' &&
      currentUser.isMCHUser
    ) {
      this.quoteService.setLockQuoteStatus(
        quote.quoteId,
        true,
        Number(currentUser.cmhUserId)
      );
    }
  }

  unlockQuote(quote: Quote, currentUser: CurrentUser) {
    if (
      quote !== undefined &&
      quote !== null &&
      currentUser !== undefined &&
      currentUser !== null &&
      quote.userId !== undefined &&
      quote.userId !== null &&
      quote.userId > 0 &&
      currentUser.cmhUserId !== undefined &&
      currentUser.cmhUserId !== null &&
      currentUser.cmhUserId !== '' &&
      currentUser.isMCHUser
    ) {
      this.quoteService.setLockQuoteStatus(
        quote.quoteId,
        false,
        Number(currentUser.cmhUserId)
      );
    }
  }

  navQuoteHistory(yes: boolean) {
    this.auditHistoryService.showQuoteHistoryModal$.next(false);
    this.showQuoteHistoryModal = false;
    this.bw.modalActive$.next(false);
    if (yes && this.quote) {
      this.router.navigate(['quote-history', this.quote.quoteId]);
    }
  }

  quoteApprovalSelection(navigate: boolean) {
    this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(false);
    this.bw.modalActive$.next(false);
    if (navigate) {
      window.location.href = `${this.mchBaseUrl}/${[
        Constants.QuoteSummaryUrl.replace(
          '#quoteid#',
          this.invalidQuote.QuoteId.toString()
        )
      ]}`;
      this.quoteApprovalService.invalidQuote$.next(null);
    }
  }

  get quoteApprovalTableDisplay(): string {
    if (
      this.invalidQuote.PlantId !== undefined &&
      this.invalidQuote.PlantId !== null &&
      this.invalidQuote.PlantId !== 0
    ) {
      return 'PLANT';
    }
    if (
      this.invalidQuote.ProductLineId !== undefined &&
      this.invalidQuote.ProductLineId !== null &&
      this.invalidQuote.ProductLineId !== 0
    ) {
      return 'PRODUCTLINE';
    }
    if (
      this.invalidQuote.ModelId !== undefined &&
      this.invalidQuote.ModelId !== null &&
      this.invalidQuote.ModelId !== 0
    ) {
      return 'MODEL';
    }
    if (
      this.invalidQuote.Options !== undefined &&
      this.invalidQuote.Options !== null &&
      this.invalidQuote.Options.length !== 0 &&
      this.invalidQuote.Options[0] !== undefined &&
      this.invalidQuote.Options[0] !== null
    ) {
      return 'OPTIONS';
    }
    return '';
  }

  ngOnDestroy() {
      this.subscription.unsubscribe();
      if (!this.unlockQuotePostCallMade) {
        this.unlockQuote(this.quote, this.currentUser);      
      }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.component.ts